import React from "react";
import logo from "../../logo-small.png";
const LogoSmall = (props) => {
    return <img src={logo} alt="SERVICE-REISEN Logo"/>;
};

export default LogoSmall;
